/**
 * The access token, wherever the login stored it. `store/auth.ts` keeps the
 * tokens in localStorage when "Zapamatovat" is ticked and in sessionStorage
 * otherwise — a reader that looks only at localStorage sends `Bearer null`
 * for the session-only login (AUDIT A2). Every raw `fetch` caller reads the
 * token through this helper; the refresh-on-401 lives in `authedFetch`.
 */
export function getAccessToken(): string | null {
  if (typeof window === 'undefined') return null
  return window.localStorage.getItem('accessToken') || window.sessionStorage.getItem('accessToken')
}
